// removed by extract-text-webpack-plugin
module.exports = {"container":"_2sxaN","list":"_1N4gw","listItem":"_3eDns"};


//////////////////
// WEBPACK FOOTER
// ./app/components/category-list/category-list.scss
// module id = 1444
// module chunks = 0